import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getapplyWorkOrder = async (params) => {
    try {
  return await get<ApiResponse<[]>>(`/workorderapplication?${params}`).then((res)=> {
        if(res?.success===true) {
            return res
        }
        else {
            return null
        }
  })
}
catch(e:any) {
    HandleApiError(e)
}
};
